
import metaMigrations from '@/store/migrations/metaMigrations';
import { migrateAsync } from '@/versioning';
import dl from '@/dataLayer';

export default {
    namespaced: true,
    actions: {
        async boot() {
            const meta = await dl.get('meta') ?? { version: 0 };
            const versions = await migrateAsync('meta', meta, metaMigrations);
            if (versions > 0)
                await dl.set('meta', meta);
        },
    },
};